import { gql, useMutation } from '@apollo/client'

export interface BackgroundTaskCreateInput {
  type: string
  payload: Record<string, unknown>
  notification_email?: string
}

export interface CreateBackgroundTaskVariables {
  input: BackgroundTaskCreateInput
}

export interface CreateBackgroundTask {
  createBackgroundTask: {
    id: number
    type: string
    status: string
    created_at: string
  }
}

export const GQL_MUTATION_CREATE_BACKGROUND_TASK = gql`
  mutation CreateBackgroundTask($input: BackgroundTaskCreateInput!) {
    createBackgroundTask(input: $input) {
      id
      type
      status
      created_at
    }
  }
`

export const useCreateBackgroundTask = () => {
  return useMutation<CreateBackgroundTask, CreateBackgroundTaskVariables>(
    GQL_MUTATION_CREATE_BACKGROUND_TASK
  )
}
